import { type OfferV11 } from '@redteclab/api/clients/bully'

import { productAccessorIsSaeOffer } from '../../../../../model/productAccessor/productAccessorIsSaeOffer'

export const shouldRenderBioLabel = (offer?: OfferV11): boolean => {
  return offer !== undefined && productAccessorIsSaeOffer(offer)
}
